import React, { Fragment, Suspense } from 'react';
import { renderRoutes } from 'react-router-config';
import { Spinner, Container } from 'react-bootstrap';

const Auth = props => {
  const { route } = props;

  return (
    <Fragment>
      <Container fluid className="d-flex flex-column vh-100 p-0">
        <Suspense
          fallback={
            <div className="d-flex justify-content-center align-items-center vh-100">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Carregando...</span>
              </Spinner>
            </div>
          }
        >
          {renderRoutes(route.routes)}
        </Suspense>
      </Container>
    </Fragment>
  );
};

export default Auth;
